<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
      Data Anggota
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.push('/keanggotaan/data-anggota/unverified')"
      >Kembali</Button>
    </div>
    <ul 
      class="nav nav-tabs bg-active border-0" 
      id="myTab" 
      role="tablist"
    >
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-diri/'+this.$route.params.id_user"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          style="background-color: #486ba7;"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true">Data Anggota</router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-sertifikasi/'+this.$route.params.id_user"
          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"          
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >
          Data Sertifikasi
        </router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-rpl/'+this.$route.params.id_user"
          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >
          Data RPL
        </router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-pelatihan/'+this.$route.params.id_user"
          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false" 
        >
          Data Pelatihan
        </router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-sanksi/' +
            this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >
          Sanksi
        </router-link>
      </li>
    </ul>
    <CCardBody>
      <CRow>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 mt-3 px-0">
          <!-- Tabs -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Profile Settings</h5>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-diri/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Diri</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-anggota/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                  style="color:#2F3AAA;font-weight:bold"
                >Data Anggota</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-dokumen/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Dokumen Pendukung</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/sanksi/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Sanksi</router-link>
              </li>
            </ul>
          </div>
          <div class="mx-3">
          <button
            type="button"
            class="btn btn-success btn-block btn-md text-white text-bold"
            @click="modalVerif = true"
          >Verifikasi Data
          </button>
          <button
            type="button"
            class="btn btn-warning btn-block btn-md text-white text-bold"
            @click="modalEmail = true"
          >Kirim Email
          </button>
          </div>
          <p
            class="text-danger font-weight-bold text-center mt-3"
            v-if="formData.statusDataKeanggotaan == '0'"
          >
            Status Data Anggota :
            <span class="badge badge-danger small">Belum Terverifikasi</span>
          </p>
          <p
            class="text-success font-weight-bold text-center mt-3"
            v-else-if="formData.statusDataKeanggotaan == '1'"
          >
            Status Data Anggota :
            <span class="badge badge-success small">Terverifikasi</span>
          </p>
        </div>
        <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 mt-3">
          <!-- small box -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Data Keanggotaan</h5>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form-data" @submit.prevent="updateDataAnggota">
                    <p class="text-bold" style="font-weight:bold;font-size:20px">Personal</p>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. Anggota</label>
                      <div class="col-sm-5">
                        <input
                          type="text"
                          class="form-control"
                          name="text"
                          :readonly="username != 'akun_yaman'"
                          id="inputEmail"
                          v-model="details.noAnggota"
                          
                        />
                      </div>
                      <div class="col-sm-2">
                        <div
                          class="btn btn-md btn-success mr-1" 
                          @click="generateNoAnggota()"
                          v-c-tooltip="'Generate Nomor Anggota'"
                          :disabled="details.statusDataDiri !== '1' && details.statusKeanggotaan !== '1' && formData.statusDataKeanggotaan !== '1'"
                        >
                          <i class="fa fa-user"></i>

                        </div>
                        <div 
                          class="btn btn-md btn-danger"
                          v-c-tooltip="'Hapus Nomor Anggota'" @click="hapusNoAnggota">
                          <i class="fa fa-trash"></i>
                        </div>
                      </div>                                                                    
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Tanggal Daftar</label>
                      <div class="col-sm-7">
                        <input
                          type="date"
                          class="form-control"
                          
                          name="email"
                          v-model="details.tanggalDaftar"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Tanggal Terakhir Diubah</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          v-model="details.updatedAt"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="kategori_anggota"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Kategori Anggota</label>
                      <div class="col-sm-7">
                        <multiselect
                          label="namaKategori"
                          placeholder="Pilih Kategori Anggota"
                          id="kotaKab"
                          @input="(value) => pilihKategoriAnggota(value)"
                          v-model="modelKategori"
                          :options="dataKategori"
                          :disabled="details.statusDataDiri !== '1' && details.statusKeanggotaan !== '1' && formData.statusDataKeanggotaan !== '1'"
                        ></multiselect>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="level" class="col-sm col-form-label" style="font-size:13px">Level</label>
                      <div class="col-sm-7">                       
                        <multiselect
                          label="namaLevel"
                          placeholder="Pilih Level"
                          @select="pilihLevel"
                          v-model="modelLevel"
                          required
                          :options="dataLevel"
                        ></multiselect>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. KTP / Paspor</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          v-model="details.noKtp"
                          class="form-control"
                          name="email"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. NPWP Pribadi</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"      
                          v-model="details.noNpwp"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. Telepon</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          v-model="details.noTelephone"
                          id="inputEmail"
                        />
                      </div>
                    </div>

                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. Register Akuntan Negara</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          id="inputEmail"
                          v-model="details.noRegistrasiAkuntanNegara"
                        />
                        <h6
                          style="color:red;margin-top:5px;font-size:12px"
                        >Diisi bila memiliki No. Register Akuntan Negara</h6>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. Izin Akuntan Publik</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"                          
                          v-model="details.noIzinAp"                          
                        />
                        <h6 style="color:red;margin-top:5px;font-size:12px">Khusus Akuntan Publik</h6>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Tanggal Registrasi Akuntan Publik</label>
                      <div class="col-sm-7">
                        <input
                          type="date"
                          class="form-control"
                          name="email"
                          v-model="details.tanggalRegistrasiAp"
                          id="inputEmail"
                        />
                        <h6 style="color:red;margin-top:5px;font-size:12px">Khusus Akuntan Publik</h6>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Kantor Akuntan Publik</label>
                      <div class="col-sm-7">
                        <multiselect
                          label="nama_kap"
                          placeholder="Pilih Kantor Akuntan Publik"
                          id="kotaKab"
                          v-model="multi_kap"
                          @input="(value) => pilihKap(value)"
                          :options="optionKap"
                        ></multiselect>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Jabatan di Instansi/KAP</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          v-model="details.jabatanAnggota"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="username"
                        class="col-sm-5 col-form-label"
                        style="font-size:13px"
                      >Terdaftar di OJK</label>
                      <div class="col-sm-7">
                        <select
                          name="id_outlet"
                          v-model="details.statusOjk"
                          @change="statusOjkSelect($event)"
                          class="form-control mb-2"
                        >
                          <option value="1" :selected="details.statusOjk == '1'">Ya</option>
                          <option value="0" :selected="details.statusOjk == '0'">Tidak</option>
                        </select>
                        <div class="row ml-1">
                          <div class="icheck-warning d-inline mr-5">
                            <input
                              type="checkbox"
                              id="checkboxWarning1"
                              :disabled="details.statusOjk == '0'"
                              v-model="details.statusOjkBankKonvensional"
                            />
                            <label
                              for="checkboxWarning1"
                              style="font-size:15px;margin-left: 4px;"
                            >Bank Konvensional</label>
                          </div>
                        </div>
                        <div class="row ml-1">
                          <div class="icheck-warning d-inline mr-5">
                            <input
                              type="checkbox"
                              id="checkboxWarning1"
                              :disabled="details.statusOjk == '0'"
                              v-model="details.statusOjkBank"
                            />
                            <label
                              for="checkboxWarning1"
                              style="font-size:15px;margin-left: 4px;"
                            >Bank Syariah</label>
                          </div>
                        </div>
                        <div class="row ml-1">
                          <div class="icheck-warning d-inline mr-5">
                            <input
                              type="checkbox"
                              id="checkboxWarning2"
                              :disabled="details.statusOjk == '0'"
                              v-model="details.statusOjkPasarModal"
                            />
                            <label
                              for="checkboxWarning2"
                              style="font-size:15px;margin-left: 4px;"
                            >Pasar Modal</label>
                          </div>
                        </div>
                        <div class="row ml-1">
                          <div class="icheck-warning d-inline">
                            <input
                              type="checkbox"
                              id="checkboxWarning3"
                              :disabled="details.statusOjk == '0'"
                              v-model="details.statusOjkIknb"
                            />
                            <label
                              for="checkboxWarning3"
                              style="font-size:15px;margin-left: 4px;"
                            >IKNB</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputSttd"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Nomor STTD</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="noSttd"
                          v-model="details.noSttd"
                          id="inputSttd"
                        />
                      </div>
                    </div>
                    <div class="form-group row mt-3">
                      <label
                        for="username"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Terdaftar di Pasar Keuangan BI</label>
                      <div class="col-sm-7">
                        <select name="id_outlet" v-model="details.statusKeuanganBi" class="form-control">
                          <option value="1" :selected="details.statusKeuanganBi == '1'">Ya</option>
                          <option value="0" :selected="details.statusKeuanganBi == '0'">Tidak</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row mt-3">
                      <label
                        for="username"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Terdaftar di BPK</label>
                      <div class="col-sm-7">
                        <select name="id_outlet" v-model="details.statusBkp" class="form-control">
                          <option value="1" :selected="details.statusBkp == '1'">Ya</option>
                          <option value="0" :selected="details.statusBkp == '0'">Tidak</option>
                        </select>
                      </div>
                    </div>
                    
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Alamat Sesuai KTP</label>
                      <div class="col-sm-7">
                        <textarea
                          class="form-control"
                          cols="30"
                          rows="5"
                          v-model="details.alamatKtp"
                        ></textarea>                        
                        <h6 style="color:red;margin-top:5px;font-size:12px">Lengkapi alamat KTP beserta RT,RW dan Kelurahan</h6>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Alamat Domisili</label>
                      <div class="col-sm-7">
                        <textarea
                          class="form-control"
                          cols="30"
                          rows="5"
                          v-model="details.alamatDomisili"
                        ></textarea>
                        <h6 style="color:red;margin-top:5px;font-size:12px">Lengkapi alamat domisili beserta RT,RW dan Kelurahan</h6>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Provinsi</label>
                      <div class="col-sm-7">
                        
                        <multiselect
                          label="name"
                          placeholder="Pilih Provinsi"
                          @select="pilihProvinsi"
                          v-model="multi_provinsi"
                          required
                          :options="optionProvinsi"
                          :loading="loading.isProvinsi"
                        ></multiselect>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Kota</label>
                      <div class="col-sm-7">                       
                         <multiselect
                          label="name"
                          placeholder="Pilih Kota Kab"
                          @select="pilihKota"
                          v-model="multi_kota_kab"
                          required
                          :options="optionKotaKab"
                          :loading="loading.isKotaKab"
                        ></multiselect>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Kecamatan</label>
                      <div class="col-sm-7">                       
                        <multiselect
                          label="name"
                          placeholder="Pilih Kecamatan"
                          @select="pilihKecamatan"
                          v-model="multi_kecamatan"
                          required
                          :options="optionKecamatan"
                          :loading="loading.isKecamatan"
                        ></multiselect>
                      </div>
                    </div>
                    
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Kode Pos</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          v-model="details.kodePos"
                          name="email"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <p class="text-bold" style="font-weight:bold;font-size:20px">Instansi</p>
                    <div class="form-group row mt-3">
                      <label
                        for="username"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Jenis Instansi</label>
                      <div class="col-sm-7">
                        <select
                          name="id_outlet"
                          v-model="details.jenisInstansi"
                          class="form-control"
                        >
                          <option
                            value="Kantor Akuntan Publik"
                            :selected="details.jenisInstansi == 'Kantor Akuntan Publik'"
                          >Kantor Akuntan Publik</option>
                          <option value="tidak" :selected="details.jenisInstansi == 'tidak'">Tidak</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="name"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Nama Instansi</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="name"
                          id="name"
                          v-model="details.namaInstansi"
                          autofocus="of"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="name"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Alamat Instansi</label>
                      <div class="col-sm-7">
                        <textarea
                          class="form-control"
                          v-model="details.alamatInstansi"
                          name
                          id
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="no_telp"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. Telepon Instansi</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          v-model="details.noTelephoneInstansi"
                          class="form-control"
                          name="name"
                          id="no_telp"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="name"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Persetujuan Kewajiban</label>
                      <div class="col-sm-7">
                        <textarea class="form-control" name id rows="8" disabled>
                          Menyatakan bahwa saya bersedia memenuhi kewajiban sesuai ketentuan dalam Anggaran Dasar,
                                    Anggaran Rumah Tangga dan Peraturan yang berlaku di Institut Akuntan Publik Indonesia (IAPI)
                                    berkaitan dengan kewajiban untuk:
                                    1. Melunasi iuran anggota sesuai jangka waktu yang ditetapkan;
                                    2. Mengikuti Pelatihan Profesional Berkelanjutan (PPL) sejumlah Satuan Kredit PPL (SKP) yang
                                    diwajibkan;
                                    3. Mematuhi Standar Profesional Akuntan Publik (SPAP) dan Kode Etik yang berlaku dalam
                                    menjalankan praktik profesi akuntan publik;
                                    4. Menandatangi Pakta Integritas sesuai yang ditetapkan;
                                    5. Menyediakan diri untuk dilakukan reviu mutu;
                                    6. Melaporkan setiap perubahan data dan alamat, serta hal-hal lain terkait dengan pemberian
                                    jasa akuntan publik.
                                    Dalam hal saya tidak memenuhi kewajiban sebagaimana disebutkan di atas, secara otomatis saya
                                    menyetujui untuk diberhentikan sebagai anggota IAPI.
                      </textarea>
                        <div class="icheck-warning d-inline mt-3">
                          <input
                            type="checkbox"
                            id="checkboxWarning1"
                            v-model="details.statusPernyataanPersetujuanKewajiban"
                          />
                          <label
                            for="checkboxWarning1"
                            class="mt-2 font-weight-bold pl-2"
                            style="font-size:12px"
                          >Pernyataan Persetujuan Kewajiban</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mt-3">
                      <label
                        for="username"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Pakta Integritas</label>
                      <div class="col-sm-7">
                        <multiselect
                            label="namaKategori"
                            v-model="paktaIntegritas"
                            @input="pilihIntegritas"
                            :options="optionPaktaIntegritas"
                            :allow-empty="false"
                            :multiple="false" 
                            placeholder="Pilih Pakta Integritas"
                            :show-labels="false"
                            required
                        ></multiselect>
                        
                        <textarea 
                          class="form-control mt-3" 
                          rows="3" 
                          v-model="deskripsiIntegritas"
                          disabled>
                        </textarea>
                        <div class="icheck-warning d-inline mt-5">
                          <input
                            type="checkbox"
                            id="checkboxWarning1"
                            v-model="details.statusPernyataanPersetujuanFaktaIntegritas"
                          />
                          <label
                            for="checkboxWarning1"
                            class="mt-2 font-weight-bold pl-2"
                            style="font-size:12px"
                          >Pernyataan Persetujuan Kewajiban</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mt-3">
                      <label
                        for="username"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Catatan Admin</label>
                      <div class="col-sm-7">
                        <textarea name="" id="" v-model="details.catatanAdmin" cols="30" rows="10" class="form-control"></textarea>
                      </div>
                    </div>
                    <div class="text-right">
                      <button class="btn btn-md btn-success mt-5">Update</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CRow>
      <!-- Modal Verifikasi -->
      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Diverifikasi Pada</label>
              <br />
              <CInput class="font-weight-bold" type="date" v-model="formData.verifikasiPada" />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="aktif"
                    value="1"
                    v-model="formData.statusDataKeanggotaan"
                  />
                  <label class="custom-control-label" for="aktif">Terverifikasi</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.statusDataKeanggotaan"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Data Peserta</h6>
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <CModal
        title="Modal title"
        :show.sync="modalEmail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postDataEmail">
          <CRow>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Subjek"
                placeholder="Masukkan Subjek"
                v-model="formEmail.subject"
              />
            </CCol>
            <CCol sm="12">
              <CTextarea
                class="font-weight-bold"
                label="Pesan"
                rows="3"
                placeholder="Masukkan isi pesan"
                v-model="formEmail.text"
              />
            </CCol>

            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <div class="custom-file text-truncate">
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="customFileLangHTML"
                    @change="fileUpload"
                  />
                  <label
                    class="custom-file-label text-truncate"
                    for="customFileLangHTML"
                    data-browse="Unggah"
                  >{{ fileName }}</label>
                </div>
                <small class="text-danger">*File harus berupa PDF max 10MB</small>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>
          <CButtonClose @click="modalEmail = false" class="text-white" />
        </template>
        <template #footer class="mt-5">
          <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
          <CButton @click="postDataEmail" type="submit" color="success">Kirim</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>

<script>
import DataKeanggotaanService from "../../../../../services/keanggotaan/data-anggota.service";
import LevelService from "../../../../../services/datamaster/level.service";
import KategoriAnggotaService from "../../../../../services/keanggotaan/kategori-anggota.service";
import { Kap } from "../../../../../mixins/master/Kap"
import { Location } from "../../../../../mixins/lokasi/Location"

export default {
  name: 'data-anggota',
  mixins : [Kap,Location],
  data() {
    return {
      modelLevel: [],
      dataLevel: [],

      dataKategori: [],
      details: {},

      fileName: "Pilih File",
      multi_kap : [],
      formData: {
        idUser: "",
        statusDataKeanggotaan: "",
        verifikasiPada: new Date().toISOString().slice(0, 10),

        idLevelAnggota: "",
        namaLevel: "",

        namaKategori: "",
        idKategori: ""
      },

      formEmail: {
        to: "",
        subject: "",
        text: "",
        attacment: ""
      },
      username : '',
      no: 1,
      modelKategori : [],
      status: false,
      optionPaktaIntegritas : [],
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      deskripsiIntegritas : '',
      paktaIntegritas : [],
    };
  },
  mounted() {    
    var user = JSON.parse(localStorage.getItem('user'));
    this.username = user.username 
    this.getKategori();
    this.getLevel();
    this.getAllKap();
    this.getAllProvinsi();
    this.getAllKotaKab();
    this.getAllKecamatan();
    this.getDataPaktaIntegritas();
    this.getData();
    this.formData.idUser = this.$route.params.id_user;
  },

  methods: {
    hapusNoAnggota() {
      this.details.noAnggota = ''
      this.details.tanggalDaftar = ''
    },
    pilihIntegritas(value) {
      this.deskripsiIntegritas = value.deskripsi;
      this.details.idKategoriPaktaIntegritas = value.idKategoriPaktaIntegritas
    },
    getDataPaktaIntegritas() {
      
      DataKeanggotaanService.getDataPaktaIntegritas()
      .then(response => {
        this.optionPaktaIntegritas = response.data.data
      }).catch(error => {
        // comment console console.log(error);
      })
    },
    pilihKota(value) {
      // comment console console.log(value)
      this.details.idKotaKab = value.id_kota_kab
    },

    pilihProvinsi(value) {      
      // comment console console.log(value)
      this.details.idProvinsi = value.idProvinsi
    },

    pilihKecamatan(value) {
      // comment console console.log(value)
      
      this.details.idKecamatan = value.idKecamatan  
    },

    pilihKap(value) {
      // comment console console.log(value)
      this.details.idKap = value ? value.id_kap : '';
    },

    pilihLevel(value) {
      // comment console console.log(value)
      this.details.idLevelAnggota = value.idLevelAnggota;
    },

    pilihKategoriAnggota(value) {
      // comment console console.log(value)
      this.details.idKategoriAnggota = value ? value.idKategoriAnggota : '';
    },

    getRandomNumbers() {
      var today = new Date().toLocaleDateString().toString();
      var now = today.split("/").join("");

      var val = Math.floor(10000 + Math.random() * 9000);
      // comment console console.log("ini today" + now);
      // comment console console.log(val);
      var randomNumber = now + val.toString();

      return randomNumber;
    },

    generateNoAnggota() {
      // this.details.noAnggota = this.getRandomNumbers();
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DataKeanggotaanService.generateNoAnggota(this.$route.params.id_user)
      .then(response => {
        // comment console console.log(response);
        // this.getData()
        this.details.noAnggota = response.data.singleData.no_anggota;
        loader.hide();
        this.alertSuccess();
      }).catch(error => {
        // comment console console.log(error)
      }) 
    },

    alertSuccessSend() {
      var vm = this;

      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,

        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Email Telah Terkirim"
      });
    },

    alertErrorSend() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Email Gagal Dikirim",
        icon: "errorr",
        showCancelButton: true
      });
    },

    statusOjkSelect(e) {
      if (e.target.value == "0") {
        this.details.statusOjkBank = false;
        this.details.statusOjkPasarModal = false;
        this.details.statusOjkIknb = false;
        this.details.statusOjkBankKonvensional = false;
      }
    },

    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },

    updateDataAnggota() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(this.details)
      DataKeanggotaanService.updateDataAnggota(
        this.$route.params.id_user,
        this.details
      )
        .then(response => {          
          loader.hide();
          this.getData();
          this.alertSuccess();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    alertSuccess() {
      var vm = this;

      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,

        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },

    alertVerif() {
      var vm = this;

      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,

        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },

    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      DataKeanggotaanService.getDataAnggota(this.$route.params.id_user)

        .then(response => {          
          var arr1 = response.data.data[0];
          var arr2 = response.data.data[1];
          this.content = response.data.data;
          var newObject1 = Object.assign({}, this.content[0]);
          var newObject2 = Object.assign({}, this.content[1]);
          var allObject = Object.assign({}, newObject1, newObject2);
          this.details = allObject;                    
          this.deskripsiIntegritas = this.details.deskripsPaktaIntegritas
          if(this.details.tanggalDaftar != null && this.details.tanggalDaftar != "") {

            var tanggalDaftar = this.details.tanggalDaftar.split("-"); // ex input "2010-01-18"
          this.details.tanggalDaftar =
            tanggalDaftar[0] +
            "-" +
            tanggalDaftar[1] +
            "-" +
            tanggalDaftar[2].substr(0, 2);
          } else {
            this.details.tanggalDaftar = ""
          }

          if( this.details.tanggalRegistrasiAp != null) {

            var tanggalRegistrasiAp = this.details.tanggalRegistrasiAp.split("-"); // ex input "2010-01-18"
            this.details.tanggalRegistrasiAp =
              tanggalRegistrasiAp[0] +
              "-" +
              tanggalRegistrasiAp[1] +
              "-" +
              tanggalRegistrasiAp[2].substr(0, 2);
          }

          this.paktaIntegritas = [
            {
              namaKategori : this.details.namaPaktaIntegritas
            }
          ]

          this.formData.statusDataKeanggotaan = this.details.statusKeanggotaan;
          this.formData.namaLevel = this.details.namaLevel;          
          var email = response.data.data[2].email;
          this.formEmail.to = email;

          var namaLevel = response.data.data[0].namaLevel;                        
          var namaKategori = response.data.data[0].namaKategori;

          vm.modelKategori = this.dataKategori.find(el => el.namaKategori === namaKategori);
          vm.modelLevel = this.dataLevel.find(el => el.namaLevel === namaLevel);
          if(vm.details.namaKap != null) {
            vm.multi_kap = {
              id_kap : vm.details.idKap,
              nama_kap : vm.details.namaKap
            }
          } else {
            vm.multi_kap = []
          }
          
          vm.multi_provinsi = {
            name : vm.details.nameProvinsi
          }
          vm.multi_kota_kab = {
            name : vm.details.nameKota
          }
          vm.multi_kecamatan = {
            name : vm.details.nameKecamatan
          }
          // setTimeout(function(){ 
          //   vm.multi_provinsi = vm.optionProvinsi.find(el => el.name === vm.details.nameProvinsi);          
          //   vm.multi_kota_kab = vm.optionKotaKab.find(el => el.name === vm.details.nameKota);            
          //   // vm.multi_kecamatan = vm.optionKecamatan.find(el => el.name === vm.details.nameKecamatan);
          //   var kotakab = vm.optionKotaKab.filter(el => el.nama_provinsi === vm.details.nameProvinsi);
          //   vm.optionKotaKab = kotakab;                                        
          //   var kec = vm.optionKecamatan.filter(el => el.idKotaKab === vm.multi_kota_kab.id_kota_kab);            
          //   vm.optionKecamatan = kec;            
          // }, 1000);          

          // if(!this.loading.isProvinsi && !this.loading.isKotaKab && !this.loading.isKecamatan) {
            
          // }

          loader.hide();
         
        }).catch(error => {
          // comment console console.log(error);
        });
    },

    getLevel() {
      LevelService.getAllLevel()
        .then(response => {
          // comment console console.log(response.data.data.content);
          this.dataLevel = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getKategori() {
      KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
          // comment console console.log(response.data.data.content);
          this.dataKategori = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    updateSelect(event) {
      var vm = this;
      this.formData.idLevelAnggota = event.idLevelAnggota;
    },
    getDataKeanggotaan() {
      var vm = this;
      KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
          vm.details = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    postData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      DataKeanggotaanService.verifikasiDataKeanggotaan(this.formData)
        .then(response => {          
          loader.hide()
          this.modalVerif = false;
          this.alertVerif();
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
        });
    },

    fileUpload(e) {
      this.formEmail.attacment = e.target.files[0];
      this.fileName = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },

    sendEmail() {
      this.modalEmail = true;
    },

    postDataEmail() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      // comment console console.log(this.formEmail.to);
      if (typeof this.formEmail.attacment === "string") {
        delete this.formEmail.attacment
      }
      if (this.formEmail.attacment === null) {
        delete this.formEmail.attacment
      }
      DataKeanggotaanService.postSendMessage(this.formEmail)
        .then(response => {
          // comment console console.log(response);
          this.alertSuccessSend();
          loader.hide();
          this.modalEmail = false;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertErrorSend();
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>